export default __webpack_public_path__ + "static/media/2-3_image1.41980897.png";